import { FiDownload, FiCreditCard, FiZap, FiMessageCircle, FiCpu, FiRefreshCw } from "react-icons/fi";

const INVOICES = [
  { id: "INV-2026-005", date: "May 10, 2026",  plan: "Pro", amount: "$79.00", status: "Pending" },
  { id: "INV-2026-004", date: "Apr 10, 2026",  plan: "Pro", amount: "$79.00", status: "Paid" },
  { id: "INV-2026-003", date: "Mar 10, 2026",  plan: "Pro", amount: "$79.00", status: "Paid" },
  { id: "INV-2026-002", date: "Feb 10, 2026",  plan: "Pro", amount: "$79.00", status: "Paid" },
  { id: "INV-2026-001", date: "Jan 10, 2026",  plan: "Pro", amount: "$79.00", status: "Paid" },
  { id: "INV-2025-012", date: "Dec 10, 2025",  plan: "Starter", amount: "$29.00", status: "Paid" },
];

const USAGE = [
  {
    icon: FiMessageCircle,
    label: "Messages",
    used: 8420,
    limit: 100000,
    color: "bg-primary",
    trackColor: "bg-primary/10",
    textColor: "text-primary",
  },
  {
    icon: FiCpu,
    label: "Chatbots",
    used: 3,
    limit: 10,
    color: "bg-indigo-500",
    trackColor: "bg-indigo-100",
    textColor: "text-indigo-600",
  },
  {
    icon: FiZap,
    label: "Conversations",
    used: 628,
    limit: null,
    color: "bg-emerald-500",
    trackColor: "bg-emerald-100",
    textColor: "text-emerald-600",
  },
];

function formatNum(n) {
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return n;
}

export default function InvoicesTab() {
  return (
    <div className="space-y-6">

      {/* ── Usage this cycle ── */}
      <div>
        <h2 className="text-sm font-bold text-gray-900 mb-4">Current billing cycle usage</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {USAGE.map(({ icon: Icon, label, used, limit, color, trackColor, textColor }) => {
            const pct = limit ? Math.min((used / limit) * 100, 100) : null;
            return (
              <div key={label} className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <div className={`w-8 h-8 rounded-lg ${trackColor} flex items-center justify-center`}>
                      <Icon size={14} className={textColor} />
                    </div>
                    <p className="text-sm font-semibold text-gray-700">{label}</p>
                  </div>
                  {limit && (
                    <span className={`text-xs font-bold ${pct > 80 ? "text-orange-500" : textColor}`}>
                      {pct?.toFixed(0)}%
                    </span>
                  )}
                </div>
                <p className="text-2xl font-bold text-gray-900 mb-1">{formatNum(used)}</p>
                {limit ? (
                  <>
                    <p className="text-xs text-gray-400 mb-2">of {formatNum(limit)} included</p>
                    <div className={`w-full h-1.5 rounded-full overflow-hidden ${trackColor}`}>
                      <div
                        className={`h-full rounded-full transition-all ${color} ${pct > 80 ? "bg-orange-400" : ""}`}
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                  </>
                ) : (
                  <p className="text-xs text-gray-400">this month</p>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Payment method + Next invoice ── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

        {/* Payment method */}
        <div className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">Payment Method</p>
          <div className="flex items-center gap-3">
            <div className="w-12 h-8 bg-gradient-to-br from-gray-800 to-gray-600 rounded-lg flex items-center justify-center shadow-sm">
              <FiCreditCard size={14} className="text-white" />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">Visa ending in 4242</p>
              <p className="text-xs text-gray-400">Expires 09 / 2027</p>
            </div>
          </div>
          <button className="mt-4 text-xs font-semibold text-primary hover:underline flex items-center gap-1">
            <FiRefreshCw size={11} /> Update payment method
          </button>
        </div>

        {/* Next invoice */}
        <div className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">Next Invoice</p>
          <p className="text-2xl font-bold text-gray-900">$79.00</p>
          <p className="text-xs text-gray-500 mt-1">Due on Jun 10, 2026</p>
          <div className="mt-3 flex items-center gap-2">
            <span className="text-xs font-semibold bg-primary-light text-primary px-2 py-0.5 rounded-full">Pro Plan</span>
            <span className="text-xs text-gray-400">Monthly billing</span>
          </div>
        </div>
      </div>

      {/* ── Invoice history ── */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-sm font-bold text-gray-900">Invoice history</h2>
          <span className="text-xs font-semibold bg-gray-100 text-gray-500 px-2.5 py-1 rounded-full">
            {INVOICES.length} invoices
          </span>
        </div>

        <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
          {/* Table header */}
          <div className="hidden sm:grid grid-cols-[1fr_1fr_1fr_1fr_auto] gap-4 px-5 py-3 bg-gray-50 border-b text-xs font-semibold text-gray-400 uppercase tracking-wider">
            <span>Invoice</span>
            <span>Date</span>
            <span>Plan</span>
            <span>Amount</span>
            <span className="w-20 text-right">Status</span>
          </div>

          {/* Rows */}
          <div className="divide-y divide-gray-50">
            {INVOICES.map((inv) => (
              <div
                key={inv.id}
                className="grid grid-cols-[1fr_auto] sm:grid-cols-[1fr_1fr_1fr_1fr_auto] gap-4 items-center px-5 py-3.5 hover:bg-gray-50/60 transition-colors"
              >
                {/* ID */}
                <div>
                  <p className="text-xs font-mono font-semibold text-gray-700">{inv.id}</p>
                  <p className="text-[11px] text-gray-400 sm:hidden mt-0.5">{inv.date} · {inv.amount}</p>
                </div>

                {/* Date */}
                <p className="hidden sm:block text-sm text-gray-600">{inv.date}</p>

                {/* Plan */}
                <div className="hidden sm:block">
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                    inv.plan === "Pro" ? "bg-primary-light text-primary" : "bg-gray-100 text-gray-600"
                  }`}>
                    {inv.plan}
                  </span>
                </div>

                {/* Amount */}
                <p className="hidden sm:block text-sm font-semibold text-gray-800">{inv.amount}</p>

                {/* Status + download */}
                <div className="flex items-center gap-2 justify-end">
                  <span className={`text-[11px] font-semibold px-2.5 py-1 rounded-full ${
                    inv.status === "Paid"
                      ? "bg-green-100 text-green-700"
                      : "bg-yellow-100 text-yellow-700"
                  }`}>
                    {inv.status}
                  </span>
                  {inv.status === "Paid" && (
                    <button
                      className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition"
                      title="Download invoice"
                    >
                      <FiDownload size={12} />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
}
